export const countryFlags = {
    EE: '🇪🇪',
    DE: '🇩🇪',
    FR: '🇫🇷',
    ES: '🇪🇸',
    IT: '🇮🇹',
    NL: '🇳🇱',
    GB: '🇬🇧',
    BE: '🇧🇪',
    CH: '🇨🇭',
    AT: '🇦🇹',
    SE: '🇸🇪',
    NO: '🇳🇴',
    DK: '🇩🇰',
    FI: '🇫🇮',
    PT: '🇵🇹',
    PL: '🇵🇱',
    CZ: '🇨🇿',
    SK: '🇸🇰',
    HU: '🇭🇺',
    RO: '🇷🇴',
    BG: '🇧🇬',
    LV: '🇱🇻',
    LT: '🇱🇹'
    // Add more countries as needed
};